import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Modal, Table } from "reactstrap";
import {
  useDeleteCustomerSchedules,
  useListCustomerSchedules,
} from "../../../hooks";
import CustomerSchedulesForm from "./CustomerSchedulesForm";

const CustomerSchedulesTable = ({ customerId, ...props }) => {
  const {
    isFetching: isLoadingCustomerSchedules,
    data: listCustomerSchedules,
    refetch: fetchCustomerSchedules,
    remove: resetListCustomerSchedules,
  } = useListCustomerSchedules({
    params: {
      columnFilter: {
        "filter[id_customer]": customerId,
        "filter[record_status]": "O",
      },
      sort: "-checker_date",
      page: -1,
    },
  });

  useEffect(() => {
    fetchCustomerSchedules();
  }, [customerId]);

  const { t, i18n } = useTranslation(["customer"]);

  // Location
  const [dataDetail, setDataDetail] = useState({});

  const onDeleteSuccess = data => {
    fetchCustomerSchedules();
  };

  const { mutate: deleteCustomerSchedules } =
    useDeleteCustomerSchedules(onDeleteSuccess);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModeCreate, setIsModeCreate] = useState(true);

  const onSuccess = location => {
    fetchCustomerSchedules();
    setIsModalOpen(false);
  };

  //
  return (
    <div>
      {/* START Schedules form modal */}
      <Modal
        isOpen={isModalOpen}
        centered
        toggle={() => {
          setIsModalOpen(!isModalOpen);
        }}
      >
        <CustomerSchedulesForm
          customerId={customerId}
          isModeCreate={isModeCreate}
          schedules={dataDetail}
          handleCancel={() => setIsModalOpen(false)}
          onSuccess={onSuccess}
        />
      </Modal>
      {/* END Schedules form modal */}
      <div className="mb-3">
        <Button
          className="btn"
          color="primary"
          disabled={isLoadingCustomerSchedules}
          onClick={() => {
            setIsModalOpen(true);
            setIsModeCreate(true);
            setDataDetail(null);
          }}
        >
          Thêm
        </Button>
      </div>
      {isLoadingCustomerSchedules ? (
        <>Đang tải ...</>
      ) : (
        <div className="custom-table">
          <Table bordered hover responsive id={`table-schedules`}>
            <thead style={{ verticalAlign: "top" }}>
              <tr>
                <th style={{ width: "20px" }}>{t("form.contact_count")}</th>
                <th>{t("form.schedules.mon")}</th>
                <th>{t("form.schedules.tue")}</th>
                <th>{t("form.schedules.wed")}</th>
                <th>{t("form.schedules.thu")}</th>
                <th>{t("form.schedules.fri")}</th>
                <th>{t("form.schedules.sat")}</th>
                <th>{t("form.schedules.sun")}</th>
                <th style={{ width: "110px" }}></th>
              </tr>
            </thead>
            <tbody>
              {listCustomerSchedules?.items?.length > 0 &&
                listCustomerSchedules.items.map((schedules, index) => {
                  return (
                    <tr key={schedules.id}>
                      <td>{index + 1}</td>
                      <td>{schedules.mon_label}</td>
                      <td>{schedules.tue_label}</td>
                      <td>{schedules.wed_label}</td>
                      <td>{schedules.thu_label}</td>
                      <td>{schedules.fri_label}</td>
                      <td>{schedules.sat_label}</td>
                      <td>{schedules.sun_label}</td>
                      <td>
                        <div
                          className="btn btn-link"
                          onClick={() => {
                            setIsModeCreate(false);
                            setDataDetail(schedules);
                            setIsModalOpen(true);
                          }}
                        >
                          <i className="fas fa-pen fa-lg text-primary"></i>
                        </div>
                        <div
                          className="btn btn-link"
                          onClick={() => {
                            deleteCustomerSchedules({
                              id_schedules: schedules?.id,
                            });
                          }}
                        >
                          <i className="fas fa-trash fa-lg text-danger"></i>
                        </div>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </Table>
        </div>
      )}
    </div>
  );
};

export default CustomerSchedulesTable;
